import type { ContactTrackerView } from '@nest-recruit/shared';

export type TrackerTestAction = 'send_link' | 'book_session' | 'move_only';

/**
 * F24.10 from the tracker: a test taken online is sent as a link; one sat on paper is booked on
 * an exam session instead (S18 Q2). Both are offered here because the Confirmed are here — ⑦ only
 * lists people already in Assessment (bug #47). A test taken outside the app sends nothing, so
 * the button only moves them to Assessment, where each result is typed in (ADR 0047). Null when
 * the job has no Assessment step.
 */
export function trackerTestAction(view: ContactTrackerView, isPaperTest: boolean): TrackerTestAction | null {
  if (!view.sendAssessment) return null;
  if (view.sendAssessment.isByHand) return 'move_only';
  return isPaperTest ? 'book_session' : 'send_link';
}

export type NextStepKind = 'assessment' | 'select' | 'interview';

/**
 * Owner, 2026-11-01 (§L32 "Send to the next step"): what the row button does. Assessment when the
 * job has one, Select when it has neither a test nor an interview (C4-a), else the first round.
 * Null for a test sat on paper: that books through "Add to exam session", which needs a session picked.
 */
export function nextStepKind(view: ContactTrackerView, testAction: TrackerTestAction | null): NextStepKind | null {
  if (view.selectFromHere) return 'select';
  if (view.usesAssessment) return testAction === 'send_link' || testAction === 'move_only' ? 'assessment' : null;
  return 'interview';
}
